<template>
  <div class="d-flex ai-center jc-center h-100">
    <span class="HEADER">
      Review<span v-if="proName"> {{proName}}</span>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import reviewParams from '@/mixins/review-params';

export default {
  name: 'review-header-content',
  mixins: [
    reviewParams,
  ],
  computed: {
    ...mapState('propublicprofile', [
      'profiles',
    ]),
    proName () {
      const profile = this.profiles.find(({ id }) => id === this.profileId);

      return profile && profile.name;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .HEADER {
    margin: 0 0 0 -30px;
    color: white;
    font-weight: 700;

    @include tablet {
      @include h4;
      margin-left: -138px;
    }
  }
</style>
